import React from "react";

export default function PDFViewer(props) {
  const { src } = props;
  return (
    <div className="h-full">
      <iframe src={src} width="100%" height="100%" />
    </div>
  );
}
